import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { MedicationDosageDisplayMode } from "@/Patient/Models/Medication/MedicationModel";

class Dosage {
    public DosageString?: string;
    public DosageFrequency?: string;
    public IfNeeded?: boolean;
    public Duration?: number;
    public DisplayMode?: MedicationDosageDisplayMode;
    public DosageServedQuantity?: string;
    public DosageServedDays?: string;
    public DosageServedFrequency?: string;
    public IsFakeDosage?: boolean;
    public DosageUnit?: number;
    public DosageTypeLookupId?: string;

    constructor(init: NonFunctionProperties<Dosage>) {
        Object.assign(this, init);
    }
}

export { Dosage };
